import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FiPhone, FiMail, FiMapPin, FiCalendar, FiGlobe } from "react-icons/fi";
import "../styles/footer.css";
 
import logo from "../assets/img/logo/logo4.png"
import { FaTiktok } from "react-icons/fa";
import { useMediaQuery } from 'react-responsive';
  

 


const Footer = () => {

     const isDesktop = useMediaQuery({ minWidth: 768 });


  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Logo + Socials */}
        <div className="footer-left">
          <div className="footer-logo">
           
          <img src={logo} alt='Roarz kreatives'/>
        
                  </div>
          <div className="footer-socials">
            <a href="https://www.instagram.com/roarz_kreatives?igsh=MXVnZWllbGZ3c3k1dw=="><FaInstagram /></a>
            <a href="https://www.facebook.com/share/14R2C7SXzgS/"><FaFacebookF /></a>
          {/*  <a href="#"><FaXTwitter /></a>*/}
             
            <a href="https://www.tiktok.com/@roarz.kreatives1?_r=1&_t=ZS-959cd5M5XDI"><FaTiktok /></a>
          </div>
         {isDesktop && <p className="footer-copy">© Roarz Kreatives</p>}
        </div>

        {/* Navigation Links */}
        <div className="footer-links">
          <ul>
            <li><a href="/digital-marketing">Digital Marketing</a></li>
            <li><a href="/website">Website Design</a></li>
             <li><a href="/invoice-generator">Invoice Generator</a></li>
            <li><a href="/crm">Crm Solutions</a></li>
 
          </ul>

          <ul>
            <li><a href="/recent-work">Work</a></li>
            <li><a href="/about-us">About</a></li>
             <li><a href="/terms">Terms</a></li>
            <li><a href="/get-in-touch">Contact Us</a></li>

          </ul>
        </div>
        
        {/* Contact Info */}
        <div className="footer-contact">
          <p><FiPhone /> +254 746 878 028</p>
          <p><FiCalendar /> Get In Touch</p>
           <hr />
           <p><FiMail /> hello@roarzkreatives.com</p>
        </div>
      </div>
                <div className="time-container footer-time">
    
            {!isDesktop &&  <p className="footer-copy">© Roarz Kreatives</p>}     

          </div>
    </footer>
  );
};

export default Footer;
